import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductType } from 'src/app/shared/models/shared.model';

import { adapter } from './reference-scheme.reducer';
import { ReferenceSchemeModuleState } from '../models/reference-scheme.model';

const { selectAll } = adapter.getSelectors();

export const getReferenceSchemeModuleState =
  createFeatureSelector<ReferenceSchemeModuleState>('referenceSchemeModule');

export const getReferenceSchemesState = createSelector(
  getReferenceSchemeModuleState,
  (state) => state.referenceSchemes,
);

export const getReferenceSchemes = createSelector(getReferenceSchemesState, selectAll);

export const getSelectedCountry = createSelector(
  getReferenceSchemeModuleState,
  (state) => state.selectedCountry,
);

export const getActiveProducts = createSelector(getReferenceSchemeModuleState, (state) =>
  state.products?.filter((product) => product.isActive && product.type === ProductType.Feed),
);
export const getActiveAdditives = createSelector(getReferenceSchemeModuleState, (state) =>
  state.products?.filter((product) => product.isActive && product.type === ProductType.Additive),
);
